export const InfoIcon = (props) => {
  return (
    <svg
      width="10"
      height="11"
      viewBox="0 0 10 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.6" clipPath="url(#clip0_1_236)">
        <path
          d="M7.07699 9.23933L6.93727 9.81051C6.5181 9.97595 6.18326 10.1019 5.93393 10.1885C5.68432 10.2753 5.3943 10.3185 5.06385 10.3185C4.5564 10.3185 4.1617 10.1942 3.88019 9.94727C3.59868 9.69937 3.45788 9.38524 3.45788 9.00416C3.45788 8.85664 3.46809 8.7049 3.48934 8.5503C3.51076 8.39552 3.54481 8.2212 3.59142 8.02636L4.11527 6.17221C4.16188 5.99467 4.20149 5.82644 4.23322 5.66736C4.26539 5.50926 4.2809 5.3638 4.2809 5.23286C4.2809 4.99607 4.23187 4.83045 4.13427 4.73733C4.03667 4.64448 3.85043 4.59734 3.57394 4.59734C3.43852 4.59734 3.29933 4.61902 3.15746 4.66097C3.01495 4.70309 2.89315 4.74378 2.79089 4.7816L2.93098 4.20998C3.27415 4.07026 3.60217 3.95061 3.91595 3.8513C4.22972 3.75173 4.5262 3.7019 4.80663 3.7019C5.31059 3.7019 5.69947 3.8237 5.97255 4.0673C6.24564 4.31108 6.38214 4.62709 6.38214 5.01651C6.38214 5.09708 6.37317 5.23904 6.3539 5.44195C6.33508 5.64531 6.30004 5.83164 6.24896 6.00112L5.72734 7.84783C5.68459 7.99615 5.64614 8.16572 5.61271 8.35653C5.57821 8.54609 5.56172 8.69092 5.56172 8.78807C5.56172 9.03329 5.61639 9.2007 5.726 9.2897C5.83641 9.3787 6.0266 9.42297 6.29672 9.42297C6.42354 9.42297 6.56784 9.40048 6.72818 9.35629C6.88807 9.31211 7.00467 9.2733 7.07699 9.23933ZM7.20928 1.4863C7.20928 1.80805 7.08802 2.08284 6.84433 2.30878C6.60127 2.53553 6.30838 2.64899 5.96574 2.64899C5.62203 2.64899 5.32842 2.53553 5.08259 2.30878C4.83719 2.08275 4.71423 1.80805 4.71423 1.4863C4.71423 1.16518 4.83719 0.889941 5.08259 0.66113C5.32798 0.432678 5.62212 0.318497 5.96574 0.318497C6.30829 0.318497 6.60127 0.432947 6.84433 0.66113C7.0882 0.889941 7.20928 1.16527 7.20928 1.4863Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_236">
          <rect
            width="10"
            height="10"
            fill="currentColor"
            transform="translate(0 0.318481)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
